import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import {useSelector} from 'react-redux';
import {Outlet} from 'react-router-dom';
import Sidebar from '../components/common/Sidebar';
import {sidebarSelector} from '../../store/selectors/sidebar';
import Header from '../components/common/header/Header';
import TransitionWrapper from '../components/pageTransitions/PageTransitionWrapper';

function BaseLayout(): JSX.Element {
    const sidebarIsColapsed = useSelector(sidebarSelector);

    return (
        <div className={`l-base ${sidebarIsColapsed ? 'is-collapsed' : ''}`}>
            <div className="l-base__sidebar">
                <Sidebar collapsed={sidebarIsColapsed} />
            </div>
            <div className="l-base__body">
                <main>
                    <Header />
                    <TransitionWrapper>
                        <Outlet />
                    </TransitionWrapper>
                </main>
            </div>
        </div>
    );
}

export default BaseLayout;
